import {createApp} from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import breadcrumbs from 'vue-3-breadcrumbs'

createApp(App).use(store).use(router).use(breadcrumbs, {
    includeComponent: false
}).mount('#app')
